/**
 * Scroll to anchors, requires link to have class of '.js-scroll-to-anchor'
 * Uses Greensock and ScrollMagic
 */

let ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
require('gsap/src/uncompressed/plugins/ScrollToPlugin.js');
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');

import $ from 'jquery';

// Init ScrollMagic controller
const controller = new ScrollMagic.Controller();

const $anchorLink = $('.js-scroll-to-anchor[href^=\\#]');

let scrollOffset = getScrollOffset();

export default function init() {
	if (!$anchorLink.length) return;
	createScenesAndBindEvents();
	scrollToSections();
}

function getScrollOffset() {
	
	// On larger screens, get all heights of the sticky nav elements
	if (($(window).width() > 952)) {
		return $('.c-top-bar').outerHeight() + $('.c-top-nav').outerHeight() + $('.c-page-nav').outerHeight();
	}
	
	return $('.c-top-bar').outerHeight();
}

function createScenesAndBindEvents() {

	let scene;

	$anchorLink.each(function() {
		const id = $(this).attr('href');

		if ($(id).length > 0) {
			scene = new ScrollMagic.Scene({
				triggerElement: id,
				duration: $(id).outerHeight(),
				triggerHook: 'onLeave'
			})
			.setClassToggle(id + '-link', 'is-active')
			.addTo(controller)
			// .addIndicators({ name: 'section' })
			.offset(-scrollOffset);

			$(this).on('click', function(e) {
				e.preventDefault();

				// If supported by the browser we can also update the URL
				if (window.history && window.history.pushState) {
					history.pushState('', document.title, id);
				}

				// trigger scroll
				controller.scrollTo(id);
			});
		}
	});
}

function scrollToSections() {

	// Change behavior of controller
	// to animate scroll instead of jump
	controller.scrollTo(function(target) {

		TweenMax.to(window, 0.5, {
			scrollTo: {
				y: target - scrollOffset + 1, // Add the 1px so that it highlights the nav as it's 'inside' the target
				autoKill: true // allows user to kill scroll action smoothly
			},
			ease: Cubic.easeInOut
		});

	});

}

export function resize() {
	scrollOffset = getScrollOffset();
}